/* unplugin-vue-components disabled */import script from "./RecruitmentProgressIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentProgressIndicator.vue?vue&type=script&setup=true&lang=js"

import "./RecruitmentProgressIndicator.vue?vue&type=style&index=0&id=59c3a2de&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c3a2de"]])

export default __exports__